module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular05-f1c2961254d12dfa706b830e5956fa0d.png";